import SiteGeneral from './modules/site-general';
import ScrollReveal from './modules/scroll-reveal';

SiteGeneral.OnReady();
ScrollReveal.OnReady();
